<template>
  <div class="InspectionLineSetting">
    <el-card>
      <el-button type="primary" slot="header" @click="returnQR">{{$t('lang.btn_returnprintQRCodeList')}}</el-button>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addPatrolRouteSettings')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column :label="$t('lang.lab_Type')" prop="name"></el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
            <template slot-scope="scope">
              <!-- 编辑路线 -->
              <el-button @click="edit(scope.row.id)">{{modifyname}}</el-button>
              <!-- 删除路线 -->
              <el-button class="orange" @click="deletes(scope.row.id)">{{deletename}}</el-button>
            </template>
          </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, jumper"
          :page-count="pageCount"
          />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:InspectionLineSetting
 *@Description:巡检路线设定
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-20
 */
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      PlanarGraphId: '', // 巡检线路ID
      PatrolTypeId: '', // 巡检类型ID
      multipleSelection: [], // 多选框
      tableData: [], // 巡检线路列表
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      deletename: require('@/config/enum').deletename,
      modifyname: require('@/config/enum').modifyname,
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
    }
  },
  created () {
    this.PlanarGraphId = this.$route.query.id
    this.PatrolTypeId = this.$route.query.typeId
    this.getList()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  methods: {
    getList() {
      let loading = this.$loading()
      this.$get(
        `/patrolPointLine?GardenId=${this.gardenId}&PlanarGraphId=${this.PlanarGraphId}&PatrolTypeId=${this.PatrolTypeId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加路线
    add() {
      this.$router.push({ name: 'addInspectionLineSetting', query: { addId: this.PlanarGraphId, addTypeId: this.PatrolTypeId } })
    },
    // 编辑路线
    edit(id) {
      this.$router.push({ name: 'addInspectionLineSetting', query: { addId: this.PlanarGraphId, addTypeId: this.PatrolTypeId, id: id } })
    },
    // 删除列表
    deletes(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$delete(`/patrolPointLine/` + id).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.commit()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    },
    // 更新列表
    commit() {
      this.pageNo = 1
      this.getList()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getList()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getList()
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 返回
    returnQR() {
      this.$router.push({ name: 'printQrCodeList' })
    }
  }
}
</script>

<style lang="scss">

</style>